<template>
  <div class="home">
    <!-- PC端 -->
    <div class="PC" v-if="facility">
      <Header :navigationIndex="navIndex" :facilityHead="facility" />
      <div class="main">
        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
            <div class="title_box">
              <div class="English_name">solution</div>
              <div class="title">解决方案</div>
              <div class="bottom_box"></div>
            </div>
            <div class="show_img_box">
              <div class="left_img">
                <div
                  class="img_box"
                  :style="{
                    backgroundImage:
                      'url(' + require('@/assets/home/' + item.path) + ')'
                  }"
                  v-for="(item, index) in solutionList.slice(0, 2)"
                  :key="index"
                  @click="handleSolutionLink(item.title)"
                >
                  <div>
                    <p class="title">{{ item.title }}</p>
                  </div>
                </div>
              </div>
              <div
                class="content_img"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/home/' + item.path) + ')'
                }"
                v-for="(item, index) in solutionList.slice(2, 3)"
                :key="index"
              >
                <div @click="handleSolutionLink(item.title)">
                  <p class="title">{{ item.title }}</p>
                </div>
              </div>
              <div class="right_img">
                <div
                  class="img_box"
                  :style="{
                    backgroundImage:
                      'url(' + require('@/assets/home/' + item.path) + ')'
                  }"
                  v-for="(item, index) in solutionList.slice(3, 5)"
                  :key="index"
                  @click="handleSolutionLink(item.title)"
                >
                  <div>
                    <p class="title">{{ item.title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="synopsis_box">
        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
            <div class="synopsis_left">
              <div class="title">company</div>
              <div class="name">公司简介</div>
              <div class="text">
                <p>
                  武汉岩石科技有限公司(简称“岩石科技”)前身为拓普康中国与北京奥腾岩石科技武汉技术研发中心，武汉大学测绘学院教学实习基地，为中国用户提供技术服务十余年，是一家专业从事地理信息装备及技术应用的高科技企业，通过了高新技术企业、双软企业
                  、瞪羚企业、专精特新企业认定，公司立足地理信息行业，致力于安全监测领域的开拓和发展。
                </p>
                <p>
                  岩石科技拥有乙级测绘资质，通过了ITSS、CS、ISO体系及3A信用等多项认证。是湖北省测绘行业协会常务理事单位、湖北省软件行业协会理事单位、武汉市建筑业协会会员单位。公司拥有“起迈安全”和“QimySafe”注册商标。为客户提供全方位一站式安全监测解决方案及端到端的技术服务。
                </p>
                <p>
                  岩石科技深耕行业十余年，始终以客户需求为导向，提供场景化解决方案。公司始终坚持创新驱动、技术引领的发展理念，在“数字定义世界、软件定义未来”的时代下，将物联网、云计算、边缘计算、机器学习等技术与多源传感器相结合，构建智能综合安全监测生态圈。产品和解决方案广泛应用于轨道交通、建设工程、桥隧健康、水利水电、地质灾害、矿山安全和文物遗址等领域，取得了广大用户好评。面向未来，岩石科技将与广大客户及合作伙伴一道，为基础设施建设与运维保驾护航。
                </p>
                <p>我们的愿景：成为全球领先的安全监测解决方案供应商</p>
                <p>我们的使命：为员工创造平台 为客户创造价值 为社会创造效益</p>
                <p>我们的使命：以奋斗者为本 勇于创新 追求卓越 合作共赢</p>
              </div>
            </div>
            <div class="synopsis_right">
              <div
                class="synopsis_icon_box"
                v-for="(item, index) in synopsisList"
                :key="index"
              >
                <img :src="item.path" alt />
                <p class="title">{{ item.title }}</p>
                <span class="name">{{ item.name }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="partner_box">
        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
            <div class="title_box">
              <div class="English_name">partner</div>
              <div class="title">合作伙伴</div>
              <div class="bottom_box"></div>
            </div>
            <div class="partner">
              <el-carousel height="6.3rem">
                <el-carousel-item
                  v-for="(item, index) in partnerList"
                  :key="index"
                >
                  <div
                    class="partner_logo"
                    v-for="(val, i) in item.child"
                    :key="i"
                  >
                    <img :src="getImgUrl(val.path)" :alt="val.name" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="news_box">
        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
            <div class="title_box">
              <div class="English_name">news</div>
              <div class="title">新闻资讯</div>
              <div class="bottom_box"></div>
            </div>
            <div class="news">
              <vue-seamless-scroll
                :data="newsList"
                :class-option="optionLeft"
                class="seamless_warp"
              >
                <div class="news_child_box">
                  <div
                    class="news_child"
                    v-for="(item, index) in newsList"
                    :key="index"
                    @click="handleNewsLink"
                  >
                    <!-- <div class="news_img" :style="{ backgroundImage: 'url('+ '@/assets/business/' + item.path + ')' }"></div> -->
                    <img
                      class="news_img"
                      :src="getImgUrls(item.path)"
                      :alt="item.name"
                    />
                    <div class="title">{{ item.title }}</div>
                    <p class="name">{{ item.name }}</p>
                    <span class="time">{{ item.time }}</span>
                  </div>
                </div>
              </vue-seamless-scroll>
            </div>
            <span class="view_more" @click="handleBusinessLink"
              >查看更多 →</span
            >
          </el-col>
        </el-row>
      </div>
      <Footer :facilityFooter="facility" />
    </div>

    <!-- 移动端 -->
    <div class="mobile" v-else>
      <indexM :facilityM="facility" />
    </div>
  </div>
</template>

<script>
import Header from '../../components/headers.vue'
import Footer from '../../components/footers.vue'
import indexM from './index_m.vue'
import homeData from '@/static/data.json'
import business from '@/static/business.json'

export default {
  name: 'home',
  data() {
    return {
      synopsisList: [
        {
          path: require('@/assets/home/synopsis_enterprise.png'),
          title: '高新技术企业',
          name:
            '获得由市科委、市财政局、市国税局、市地税局颁发的“高新技术企业”证书。'
        },
        {
          path: require('@/assets/home/synopsis_innovate.png'),
          title: '创新运营',
          name:
            '由软硬件及解决方案销售模式走向"软件+硬件+解决方案+服务"创新运营模式。'
        },
        {
          path: require('@/assets/home/synopsis_success.png'),
          title: '安全监测',
          name:
            '轨道交通、建设工程、桥隧健康、水利水电、地质灾害等领域提供优质安全监测服务。'
        },
        {
          path: require('@/assets/home/synopsis_certificate.png'),
          title: '资质证书',
          name:
            '拥有乙级测绘资质证书和信息系统集成资质证书，及多项专利证书和软件著作权证书。'
        }
      ],
      newsList: [
        {
          path: require('@/assets/home/solution1.jpg'),
          title: '建筑基坑',
          name: '建筑基坑监测需要对主体结构进行监测，以保证项目施工的安全',
          time: '2021-02-03'
        },
        {
          path: require('@/assets/home/solution1.jpg'),
          title: '文物遗址',
          name: '建筑基坑监测需要对主体结构进行监测，以保证项目施工的安全',
          time: '2021-02-03'
        },
        {
          path: require('@/assets/home/solution1.jpg'),
          title: '边坡监测',
          name: '建筑基坑监测需要对主体结构进行监测，以保证项目施工的安全',
          time: '2021-02-03'
        },
        {
          path: require('@/assets/home/solution1.jpg'),
          title: '高铁监测',
          name: '建筑基坑监测需要对主体结构进行监测，以保证项目施工的安全',
          time: '2021-02-03'
        }
      ],
      solutionList: [],
      partnerList: [],
      facility: true, // 设备
      navIndex: 0
    }
  },

  computed: {
    optionLeft() {
      return {
        limitMoveNum: this.newsList.length,
        direction: 2
      }
    }
  },

  created() {
    // console.log(screen.width )
    if (screen.width < 768) {
      // 768，ipad
      this.facility = false
      // window.location.href="http://localhost:9090"; // 去移动端页面
    } else {
      this.facility = true
    }
    this.partnerList = homeData.data.partner
    this.solutionList = homeData.data.solution
    this.newsList = business.data.data
  },

  methods: {
    // 解决方案跳转
    handleSolutionLink(val) {
      this.$router.push('solution')
      let navigation = {
        title: '解决方案',
        index: 2,
        child: {
          name: val
        }
      }
      sessionStorage.setItem('navigation', JSON.stringify(navigation))
    },

    // 新闻资讯跳转
    handleNewsLink() {
      this.$router.push('business')
      let navigation = {
        title: '行业案例',
        index: 3
      }
      sessionStorage.setItem('navigation', JSON.stringify(navigation))
    },
    handleBusinessLink() {
      this.$router.push('business')
      let navigation = {
        title: '行业案例',
        index: 3
      }
      sessionStorage.setItem('navigation', JSON.stringify(navigation))
    },

    getImgUrl(src) {
      return require('@/assets/home/' + src)
    },
    getImgUrls(src) {
      return require('@/assets/business/' + src)
    }
  },

  components: {
    Header,
    Footer,
    indexM
  }
}
</script>

<style lang="scss" scoped>
.home {
  font-family: PingFang SC;
  .header_box {
    width: 100%;
    line-height: 0.96rem;
    background-color: rgba($color: #000000, $alpha: 0.1);
    position: absolute;
    z-index: 30;
    font-size: 0.247rem;
    font-weight: 500;
    color: #cbecff;
  }

  .main {
    background-color: #fafafa;
    .show_img_box {
      margin-top: 0.9rem;
      display: flex;
      .left_img,
      .right_img {
        div {
          width: 4.8rem;
          height: 3.2rem;
        }
        div:first-child {
          margin-bottom: 0.2rem;
        }
        .img_box {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          position: relative;
          cursor: pointer;
          div {
            background: rgba($color: #000000, $alpha: 0);
          }
        }
        .img_box div:hover {
          transition: all 1s;
          background: rgba($color: #000000, $alpha: 0.5);
        }
      }
      .content_img {
        width: 100%;
        height: 6.6rem;
        margin: 0 0.2rem;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        > div {
          cursor: pointer;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.2);
          color: #fff;
          font-size: 0.186rem;
          font-weight: bold;
          text-align: center;
          position: relative;
        }
        div:hover {
          transition: all 1s;
          background: rgba($color: #000000, $alpha: 0.5);
        }
      }
      .title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        color: #fff;
        font-size: 0.216rem;
        font-weight: bold;
      }
    }
  }
  .synopsis_box {
    width: 100%;
    height: 7.68rem;
    background: url(../..//assets/home/synopsis_bg.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 1.34rem;
    color: #fff;
    box-sizing: border-box;
    .el-col {
      display: flex;
      justify-content: space-between;
      .synopsis_left {
        margin-top: 0.98rem;
        width: 4.76rem;
        height: 100%;
        .title {
          font-size: 0.742rem;
        }
        .name {
          margin-top: 0.1rem;
          font-size: 0.495rem;
        }
        .text {
          font-size: 0.206rem;
          margin-top: 0.3rem;
          line-height: 0.36rem;
          text-transform: uppercase;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 12; /*显示的行数*/
          overflow: hidden;
          p {
            text-indent: 2em;
          }
        }
      }
      .synopsis_right {
        margin-top: 0.98rem;
        width: 8.42rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .synopsis_icon_box {
          width: 3.66rem;
          margin-bottom: 0.3rem;
          img {
            width: 1.16rem;
            height: 1.16rem;
          }
          .title {
            font-size: 0.309rem;
            margin: 0.24rem 0;
          }
          .name {
            font-size: 0.186rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }
  .partner_box {
    width: 100%;
    height: 11.67rem;
    background: url(../..//assets/home/partner_bg.png) no-repeat;
    background-size: 100% 100%;
    .el-col {
      .partner {
        margin-top: 0.9rem;
        width: 100%;
        height: 6.3rem;
        background-color: #fff;
        .el-carousel__item {
          display: flex;
          flex-wrap: wrap;
          .partner_logo {
            width: 25%;
            height: 3.14rem;
            position: relative;
            box-sizing: border-box;
            img {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translateX(-50%) translateY(-50%);
            }
          }
          .partner_logo:nth-child(-n + 4) {
            border-right: 1px #eee solid;
            border-bottom: 1px #eee solid;
          }
          .partner_logo:nth-child(n + 4) {
            border-right: 1px #eee solid;
          }
          .partner_logo:nth-child(4),
          .partner_logo:last-child {
            border-right: none;
          }
        }
      }
    }
  }
  .news_box {
    width: 100%;
    height: 11.67rem;
    background: url(../../assets/home/news_bg.png) no-repeat;
    background-size: 100% 100%;
    .el-col {
      .news {
        margin-top: 0.8rem;
        width: 100%;
        height: 5.3rem;
        overflow: hidden;
        .seamless_warp {
          overflow: hidden;
          .news_child_box {
            display: flex;
            .news_child {
              margin-right: 0.2rem;
              width: 3.45rem;
              height: 5.3rem;
              background-color: #fff;
              border-radius: 0.1rem 0.1rem;
              overflow: hidden;
              cursor: pointer;
              box-shadow: 1px 0.02rem 0.15rem 1px rgba(140, 140, 140, 0.22);
              img {
                width: 100%;
                height: 3.16rem;
              }
              .title {
                color: #0a5191;
                font-size: 0.309rem;
                margin: 0.2rem 0.2rem;
              }
              .name,
              .time {
                margin: 0.2rem 0.2rem;
                font-size: 0.186rem;
                color: #a1a1a1;
              }
            }
          }
        }
      }
      .view_more {
        margin: 1.7rem 50% 0 50%;
        transform: translateX(-50%);
        font-size: 0.247rem;
        color: #5289f4;
        display: inline-block;
        width: 1.4rem;
        cursor: pointer;
      }
    }
  }

  .title_box {
    text-align: center;
    margin-top: 0.6rem;
    .English_name {
      text-transform: uppercase;
      color: #999;
      font-size: 0.309rem;
      font-weight: 400;
    }
    .title {
      color: #333;
      font-size: 0.495rem;
      font-weight: 500;
      margin: 0.2rem 0 0.3rem 0;
    }
    .bottom_box {
      width: 1.12rem;
      height: 0.05rem;
      background-color: #5289f4;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue